"use client"

/**
 * Unsaved-work confirm modal (Lane D).
 *
 * 3 actions per design review:
 *   - "Lưu nháp và tiếp tục" — save then navigate (when supported)
 *   - "Bỏ thay đổi"          — discard, navigate
 *   - "Ở lại"                 — cancel navigation
 *
 * Used by route-away handlers and the header site switcher (which already
 * watches `window.__adminHasUnsavedWork`).
 *
 * Pass `onSaveDraftAndContinue={undefined}` to omit the save option for
 * pages where draft save is not supported.
 */

import { Modal } from "antd"

interface UnsavedWorkModalProps {
  open: boolean
  onSaveDraftAndContinue?: () => Promise<void> | void
  onDiscard: () => void
  onStay: () => void
  title?: string
  message?: string
}

export function UnsavedWorkModal({
  open,
  onSaveDraftAndContinue,
  onDiscard,
  onStay,
  title = "Có thay đổi chưa lưu",
  message = "Trang này có thay đổi chưa được lưu. Tiếp tục sẽ mất các thay đổi.",
}: UnsavedWorkModalProps) {
  return (
    <Modal
      open={open}
      title={title}
      centered
      onCancel={onStay}
      footer={[
        <button
          key="stay"
          type="button"
          onClick={onStay}
          className="ant-btn ant-btn-default"
        >
          Ở lại
        </button>,
        <button
          key="discard"
          type="button"
          onClick={onDiscard}
          className="ant-btn ant-btn-default"
          style={{
            borderColor: "var(--admin-danger)",
            color: "var(--admin-danger)",
          }}
        >
          Bỏ thay đổi
        </button>,
        onSaveDraftAndContinue && (
          <button
            key="save"
            type="button"
            onClick={() => onSaveDraftAndContinue()}
            className="ant-btn ant-btn-primary"
          >
            Lưu nháp và tiếp tục
          </button>
        ),
      ].filter(Boolean)}
    >
      <p style={{ margin: 0, color: "var(--admin-foreground)", lineHeight: 1.6 }}>
        {message}
      </p>
    </Modal>
  )
}

export default UnsavedWorkModal
